const state = {
  problemInfo: {},
  problems: null,
  problemsPageCount: 0,
  problemsPage: 1
}
const getters = {
  getWQuestionModule: state => name => state[name]
}
const mutations = {
  setWQuestionModule (state, { type, data }) {
    state[type] = data
  }
}
const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/WebinarQuestion.js